import InputGroup from '@shared/components/InputGroup/InputGroup';
import { ChangeEvent } from 'react';

import { ReactComponent as Layout } from 'assets/icons/Layout.svg';

interface RoomNameInputProps {
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  errorMessage?: string;
  placeholder?: string;
  dataTestId?: string;
}

const RoomNameInput = ({ value, onChange, errorMessage, placeholder, dataTestId }: RoomNameInputProps) => (
  <div className="flex w-full gap-2 items-center">
    <div className="p-3">
      <Layout className="stroke-gray-60 h-6 w-6 shrink-0 stroke-1.5" />
    </div>
    <InputGroup variant="white-bg" errorMessage={errorMessage}>
      <InputGroup.Input
        onChange={onChange}
        value={value}
        placeholder={placeholder}
        data-testid={dataTestId}
        className="!bg-gray-10"
      />
    </InputGroup>
  </div>
);

export default RoomNameInput;
